<div class="modal-header confirm">
  <h2 class="modal-title">{{ title }}</h2>
  <button (click)="closeModal();" aria-label="Close" class="reset-width close" data-dismiss="modal" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body text-center">
  <p [innerHTML]="message"></p>
</div>
<div class="modal-footer">
  <div class="container">
    <div class="row">
      @if (showOnlyOkBtb) {
        <div class="col-md-12">
          <button (click)="accept()" class="btn fill-button btn-light btn-block btn-margin-top" type="button">
            <span>{{ btnOkText }}</span> <i class="fa fa-check"></i>
          </button>
        </div>
      }

      @if (!showOnlyOkBtb) {
        <div class="col-lg-6 col-xs-3 align-self-start">
          <button (click)="decline()" class="btn btn-light btn-block btn-margin-top" type="button">
            <span>{{ btnCancelText }}</span> <i class="fa fa-close"></i>
          </button>
        </div>
        <div class="col-lg-6 col-xs-3 align-self-end">
          <button (click)="accept()" class="btn btn-dark btn-block btn-margin-top" type="button">
            <span>{{ btnOkText }}</span> <i class="fa fa-check"></i>
          </button>
        </div>
      }

    </div>
  </div>
</div>